import { APP_INITIALIZER, ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAuth } from 'angular-auth-oidc-client';
import { environment } from '../environments/environments';
import { headerInterceptor } from './header.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(withFetch(), withInterceptors([headerInterceptor])),
    provideAuth({
      config: environment.identityConfig
    }),
    // provideClientHydration()
    // provideAnimations(),   
    // provideToastr({         
    //   positionClass: 'toast-top-right',
    //   timeOut: 5000,
    //   preventDuplicates: true,
    //   newestOnTop: true,
    //   maxOpened: 3,
    //   autoDismiss: true
    // }),
  ]
};
